var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.9,
    height: 17.5,
    viewBox: "0 0 15.9 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-lock",
    "data-name": "Icon feather-lock",
    transform: "translate(-3.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37874",
    "data-name": "Path 37874",
    d: "M6.1,15.75H17.3a2.353,2.353,0,0,1,2.35,2.35v5.6a2.353,2.353,0,0,1-2.35,2.35H6.1A2.353,2.353,0,0,1,3.75,23.7V18.1A2.353,2.353,0,0,1,6.1,15.75Zm11.2,8.8a.851.851,0,0,0,.85-.85V18.1a.851.851,0,0,0-.85-.85H6.1a.851.851,0,0,0-.85.85v5.6a.851.851,0,0,0,.85.85Z",
    transform: "translate(0 -6.3)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37875",
    "data-name": "Path 37875",
    d: "M18.5,10.95a.75.75,0,0,1-.75-.75V7a3.25,3.25,0,1,0-6.5,0v3.2a.75.75,0,0,1-1.5,0V7a4.75,4.75,0,0,1,9.5,0v3.2A.75.75,0,0,1,18.5,10.95Z",
    transform: "translate(-2.8 0)",
    fill: "#979797"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f413a658319c76abab2976919feb8122.svg";
export { ForwardRef as ReactComponent };